import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CoacheeProfileDocumentsController } from 'presentation/page/profile/coachee-profile/coachee-profile-documents/coachee-profile-documents.controller';

@Component({
	selector: 'spr-coachee-profile-documents-header',
	templateUrl: './coachee-profile-documents-header.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class:
			'md:flex hidden md:flex-none md:items-center md:bg-grey-alabaster md:p-3 md:space-x-3',
	},
})
export class CoacheeProfileDocumentsHeaderComponent {
	constructor(public controller: CoacheeProfileDocumentsController) {}
}
